import { render } from "./DashInfoView.vue?vue&type=template&id=078f0b0e"
import script from "./DashInfoView.vue?vue&type=script&lang=js"
export * from "./DashInfoView.vue?vue&type=script&lang=js"

import "./DashInfoView.vue?vue&type=style&index=0&id=078f0b0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__